/**
 * Decodes a priority value to its human-readable string representation
 * @param priority - The priority value (number, string, or already decoded)
 * @param decodedPriority - Optional pre-decoded priority value
 * @returns The decoded priority string
 */
export const decodePriority = (
  priority: number | string | undefined,
  decodedPriority?: string
): string => {
  // If already decoded, return it
  if (decodedPriority) {
    return decodedPriority;
  }

  // If no priority value, return empty or default
  if (priority === undefined || priority === null || priority === '') {
    return '';
  }

  // Check if priority is numeric (number type or numeric string)
  const isNumeric = typeof priority === 'number' || 
                    (typeof priority === 'string' && !isNaN(Number(priority)));

  if (isNumeric) {
    const numericPriority = Number(priority);
    switch (numericPriority) {
      case 1:
        return 'Low';
      case 2:
        return 'Normal';
      case 3:
        return 'High';
      case 4:
        return 'Urgent';
      default:
        return String(priority);
    }
  }

  // Non-numeric string, return as-is
  return String(priority);
};
